/**
 * ZIP-code popup and region-based link rewriting.
 * When user selects ZIP (LA / SF / Honolulu): rewrite all collection and product links
 * to point to the duplicated versions (-la, -sf, -hnl). Nothing is hidden — links are replaced.
 * Cookie: store_city = los_angeles | honolulu | san_francisco | other
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'store_city';
  var COOKIE_DAYS = 365;
  var BODY_ATTR = 'data-store-city';
  var ORIGINAL_HREF = 'data-original-href';
  var REWRITTEN_ATTR = 'data-region-rewritten';
  var DATA_REGION = 'data-region';

  /* PCREGION FALLBACK 2026-06-27: whitelist of regional collection handles that actually resolve
     (real collections + URL redirects). rewriteLink consults this so a /collections/ link is only
     region-rewritten when the target exists; otherwise the working base link is kept (no 404). */
  var PC_TWIN_COLL = {"sf":{"100-250-sf":1,"200-sf":1,"250-350-sf":1,"350-sf":1,"aisle-wedding-flowers-sf":1,"all-flowers-sf":1,"all-sf":1,"anniversary-flowers-delivery-sf":1,"apology-flowers-sf":1,"arrangement-sf":1,"baskets-sf":1,"best-sellers-sf":1,"birthday-flowers-delivery-sf":1,"black-flowers-delivery-los-angeles-sf":1,"blue-sf":1,"bridal-bouquet-sf":1,"calla-lilies-sf":1,"cart-upsell-sf":1,"christmas-sf":1,"corporate-event-flowers-los-angeles-sf":1,"corporate-flower-arrangements-gifts-sf":1,"designer-floral-arrangements-los-angeles-sf":1,"exclusive-collection-sf":1,"exclusive-sf":1,"exotic-tropical-flowers-delivery-los-angeles-sf":1,"fall-florals-collection-sf":1,"father-s-day-sf":1,"floral-therapy-collection-sf":1,"floral-therapy-sf":1,"flowers-bouquet-sf":1,"flowers-box-delivery-sf":1,"flowers-on-sale-sf":1,"flowers-safe-for-cats-sf":1,"flowers-safe-for-dogs-sf":1,"flowers-under-99-sf":1,"for-him-sf":1,"fourth-of-july-flowers-sf":1,"french-vibes-sf":1,"frontpage-sf":1,"funeral-flowers-delivery-sf":1,"funeral-sf":1,"get-well-sf":1,"gifts-delivery-sf":1,"green-flowers-delivery-los-angeles-sf":1,"hanukkah-sf":1,"heart-collection-sf":1,"hydrangea-delivery-in-sf":1,"just-because-flowers-sf":1,"lilies-delivery-sf":1,"love-romance-sf":1,"luxury-flower-arrangements-sf":1,"luxury-flower-gifts-los-angeles-sf":1,"main-collection-sf":1,"mixed-flowers-sf":1,"mothers-day-flowers-delivery-sf":1,"new-baby-sf":1,"new-sf":1,"orchids-sf":1,"peach-orange-flowers-delivery-los-angeles-sf":1,"peonies-delivery-sf":1,"pink-sf":1,"plants-delivery-sf":1,"preserved-roses-sf":1,"pride-month-flowers-los-angeles-sf":1,"proposal-pathway-decor-sf":1,"purple-flowers-delivery-los-angeles-sf":1,"red-flowers-delivery-sf":1,"roses-delivery-sf":1,"same-day-flower-delivery-sf":1,"seasonal-flowers-sf":1,"shabbat-sf":1,"spring-sale-sf":1,"subscribe-save-sf":1,"sunflowers-delivery-sf":1,"sympathy-flower-delivery-sf":1,"top-rated-sf":1,"tulips-delivery-sf":1,"valentine-s-day-1-sf":1,"wedding-arches-sf":1,"wedding-centerpieces-los-angeles-sf":1,"wedding-sf":1,"white-flowers-delivery-sf":1,"yellow-sf":1},"hnl":{"100-250-hnl":1,"200-hnl":1,"250-350-hnl":1,"350-hnl":1,"aisle-wedding-flowers-hnl":1,"all-flowers-hnl":1,"all-hnl":1,"anniversary-flowers-delivery-hnl":1,"apology-flowers-hnl":1,"arrangement-hnl":1,"baskets-hnl":1,"best-sellers-hnl":1,"birthday-flowers-delivery-hnl":1,"black-flowers-delivery-los-angeles-hnl":1,"blue-hnl":1,"bridal-bouquet-hnl":1,"calla-lilies-hnl":1,"cart-upsell-hnl":1,"christmas-hnl":1,"corporate-event-flowers-los-angeles-hnl":1,"corporate-flower-arrangements-gifts-hnl":1,"designer-floral-arrangements-los-angeles-hnl":1,"exclusive-collection-hnl":1,"exclusive-hnl":1,"exotic-tropical-flowers-delivery-los-angeles-hnl":1,"fall-florals-collection-hnl":1,"father-s-day-hnl":1,"floral-therapy-collection-hnl":1,"floral-therapy-hnl":1,"flowers-bouquet-hnl":1,"flowers-box-delivery-hnl":1,"flowers-on-sale-hnl":1,"flowers-safe-for-cats-hnl":1,"flowers-safe-for-dogs-hnl":1,"flowers-under-99-hnl":1,"for-him-hnl":1,"fourth-of-july-flowers-hnl":1,"french-vibes-hnl":1,"frontpage-hnl":1,"funeral-flowers-delivery-hnl":1,"funeral-hnl":1,"get-well-hnl":1,"gifts-delivery-hnl":1,"green-flowers-delivery-los-angeles-hnl":1,"hanukkah-hnl":1,"heart-collection-hnl":1,"hydrangea-delivery-in-hnl":1,"just-because-flowers-hnl":1,"lilies-delivery-hnl":1,"love-romance-hnl":1,"luxury-flower-arrangements-hnl":1,"luxury-flower-gifts-los-angeles-hnl":1,"main-collection-hnl":1,"mixed-flowers-hnl":1,"mothers-day-flowers-delivery-hnl":1,"new-baby-hnl":1,"new-hnl":1,"orchids-hnl":1,"peach-orange-flowers-delivery-los-angeles-hnl":1,"peonies-delivery-hnl":1,"pink-hnl":1,"plants-delivery-hnl":1,"preserved-roses-hnl":1,"pride-month-flowers-los-angeles-hnl":1,"proposal-pathway-decor-hnl":1,"purple-flowers-delivery-los-angeles-hnl":1,"red-flowers-delivery-hnl":1,"roses-delivery-hnl":1,"same-day-flower-delivery-hnl":1,"seasonal-flowers-hnl":1,"shabbat-hnl":1,"spring-sale-hnl":1,"subscribe-save-hnl":1,"sunflowers-delivery-hnl":1,"sympathy-flower-delivery-hnl":1,"top-rated-hnl":1,"tulips-delivery-hnl":1,"valentine-s-day-1-hnl":1,"wedding-arches-hnl":1,"wedding-centerpieces-los-angeles-hnl":1,"wedding-hnl":1,"white-flowers-delivery-hnl":1,"yellow-hnl":1},"vc":{"100-250-vc":1,"200-vc":1,"250-350-vc":1,"350-vc":1,"aisle-wedding-flowers-vc":1,"all-flowers-vc":1,"all-vc":1,"anniversary-flowers-delivery-vc":1,"apology-flowers-vc":1,"arrangement-vc":1,"baby-shower-flowers-vc":1,"baskets-vc":1,"best-sellers-vc":1,"birthday-flowers-delivery-vc":1,"black-flowers-delivery-los-angeles-vc":1,"blue-vc":1,"bridal-bouquet-vc":1,"calla-lilies-vc":1,"cart-upsell-vc":1,"christmas-vc":1,"church-chapel-funeral-flowers-los-angeles-vc":1,"corporate-event-flowers-los-angeles-vc":1,"corporate-flower-arrangements-gifts-vc":1,"designer-floral-arrangements-los-angeles-vc":1,"exclusive-collection-vc":1,"exclusive-vc":1,"exotic-tropical-flowers-delivery-los-angeles-vc":1,"fall-florals-collection-vc":1,"father-s-day-vc":1,"floral-therapy-collection-vc":1,"floral-therapy-vc":1,"flowers-bouquet-vc":1,"flowers-box-delivery-vc":1,"flowers-on-sale-vc":1,"flowers-safe-for-cats-vc":1,"flowers-safe-for-dogs-vc":1,"flowers-under-99-vc":1,"for-him-vc":1,"fourth-of-july-flowers-vc":1,"french-vibes-vc":1,"funeral-flowers-delivery-vc":1,"get-well-vc":1,"gifts-delivery-vc":1,"graduation-flowers-delivery-vc":1,"green-flowers-delivery-los-angeles-vc":1,"halloween-flowers-vc":1,"hanukkah-vc":1,"heart-collection-vc":1,"hydrangea-delivery-in-vc":1,"just-because-flowers-vc":1,"lilies-delivery-vc":1,"love-romance-vc":1,"luxury-flower-arrangements-vc":1,"luxury-flower-gifts-los-angeles-vc":1,"main-collection-vc":1,"mixed-flowers-vc":1,"mothers-day-flowers-delivery-vc":1,"new-baby-vc":1,"new-vc":1,"new-year-flowers-delivery-vc":1,"office-plants-vc":1,"orchids-vc":1,"peach-orange-flowers-delivery-los-angeles-vc":1,"peonies-delivery-vc":1,"pink-vc":1,"plants-delivery-vc":1,"preserved-roses-vc":1,"pride-month-flowers-los-angeles-vc":1,"proposal-pathway-decor-vc":1,"purple-flowers-delivery-los-angeles-vc":1,"red-flowers-delivery-vc":1,"roses-delivery-vc":1,"same-day-flower-delivery-vc":1,"seasonal-flowers-vc":1,"shabbat-vc":1,"spring-sale-vc":1,"subscribe-save-vc":1,"sunflowers-delivery-vc":1,"sympathy-flower-delivery-vc":1,"top-rated-vc":1,"tulips-delivery-vc":1,"valentine-s-day-1-vc":1,"wedding-arches-vc":1,"wedding-centerpieces-los-angeles-vc":1,"wedding-vc":1,"white-flowers-delivery-vc":1,"yellow-vc":1}};

  // Full ZIP code lists per location
  var LA_ZIPS = ["90001","90002","90003","90004","90005","90006","90007","90008","90010","90011","90012","90013","90014","90015","90016","90017","90018","90019","90020","90021","90022","90023","90024","90025","90026","90027","90028","90029","90031","90032","90033","90034","90035","90036","90037","90038","90039","90040","90041","90042","90043","90044","90045","90046","90047","90048","90049","90056","90057","90058","90059","90061","90062","90063","90064","90065","90066","90067","90068","90069","90071","90074","90077","90079","90084","90088","90089","90090","90094","90095","90096","90099","90101","90102","90103","90134","90189","90201","90210","90211","90212","90220","90221","90222","90230","90232","90240","90241","90242","90245","90247","90248","90249","90250","90254","90255","90260","90261","90262","90266","90270","90272","90274","90275","90277","90278","90280","90290","90291","90292","90293","90301","90302","90303","90304","90305","90311","90313","90397","90398","90401","90402","90403","90404","90405","90501","90502","90503","90504","90505","90506","90601","90602","90603","90604","90605","90606","90612","90638","90639","90640","90650","90659","90660","90670","90701","90703","90706","90710","90712","90713","90715","90716","90717","90723","90731","90732","90744","90745","90746","90747","90755","90802","90803","90804","90805","90806","90807","90808","90810","90813","90814","90815","90822","90831","90833","90834","90835","90840","90842","90844","90845","90846","90847","90848","90888","90895","90899","91001","91006","91007","91008","91010","91011","91016","91020","91024","91030","91040","91042","91101","91103","91104","91105","91106","91107","91108","91110","91121","91123","91124","91125","91126","91129","91131","91182","91184","91185","91188","91189","91191","91199","91201","91202","91203","91204","91205","91206","91207","91208","91210","91214","91306","91316","91321","91324","91325","91326","91329","91330","91331","91335","91340","91342","91343","91344","91345","91351","91352","91356","91364","91382","91383","91387","91388","91399","91401","91402","91403","91405","91406","91411","91423","91436","91470","91482","91495","91496","91497","91499","91501","91502","91504","91505","91506","91521","91522","91523","91526","91601","91602","91604","91605","91606","91607","91608","91611","91612","91702","91706","91722","91723","91731","91732","91733","91735","91744","91745","91746","91748","91754","91755","91756","91770","91771","91772","91775","91776","91780","91790","91791","91792","91797","91801","91803","91804","91841","93550"];
  var HONOLULU_ZIPS = ["96701","96706","96707","96709","96712","96717","96730","96731","96734","96744","96759","96762","96782","96786","96789","96791","96792","96795","96797","96801","96802","96803","96804","96805","96806","96807","96808","96809","96810","96811","96812","96813","96814","96815","96816","96817","96818","96819","96820","96821","96822","96823","96824","96825","96826","96827","96828","96830","96835","96836","96837","96838","96839","96840","96841","96842","96843","96844","96845","96846","96847","96848","96849","96850","96853","96854","96857","96858","96859","96860","96861","96862","96863","96898"];
  var VENTURA_ZIPS = ["91320","93012","91360","91361","91362","93010","93033","93042","90265","91301","91363","91377","93004","93021","93030","93035","93036","93041","93043","93066","90263","91302","91307","93003","93060","93063","93064","93065","93093","93099","91303","91304","91311","91367","93009","93015","91355","91381","93001","93022"];
  var OC_ZIPS = ["90620","90621","90623","90630","90631","90680","90720","90740","92602","92603","92604","92606","92610","92612","92614","92617","92618","92620","92625","92626","92627","92629","92630","92637","92646","92647","92648","92649","92651","92653","92655","92656","92657","92660","92661","92662","92663","92675","92676","92677","92679","92683","92688","92691","92692","92694","92697","92698","92701","92703","92704","92705","92706","92707","92708","92709","92710","92725","92780","92782","92799","92801","92802","92804","92805","92806","92807","92808","92809","92821","92831","92832","92833","92835","92840","92841","92843","92844","92845","92850","92861","92862","92865","92866","92867","92868","92869","92870","92886","92887","92899"];
  var IE_ZIPS = ["91701","91708","91709","91710","91711","91724","91730","91737","91739","91740","91741","91750","91752","91758","91761","91762","91763","91764","91765","91766","91767","91768","91773","91784","91786","91789","91795","91798","91799","92313","92316","92324","92335","92336","92337","92358","92376","92377","92401","92403","92405","92407","92410","92411","92415","92418","92424","92501","92503","92504","92505","92506","92507","92509","92521","92522","92823","92860","92878","92879","92880","92881","92882"];
  var SF_ZIPS = ["94002","94003","94005","94010","94011","94012","94013","94014","94015","94016","94017","94018","94019","94022","94023","94024","94025","94026","94027","94028","94029","94030","94031","94035","94037","94038","94039","94040","94041","94042","94043","94044","94045","94059","94061","94062","94063","94064","94065","94066","94067","94070","94071","94074","94080","94083","94089","94096","94098","94099","94101","94102","94103","94104","94105","94106","94107","94108","94109","94110","94111","94112","94114","94115","94116","94117","94118","94119","94120","94121","94122","94123","94124","94125","94126","94127","94128","94129","94130","94131","94132","94133","94134","94135","94136","94137","94138","94139","94140","94141","94142","94143","94144","94145","94146","94147","94150","94151","94152","94153","94154","94155","94156","94157","94158","94159","94160","94161","94162","94163","94164","94165","94166","94167","94168","94169","94170","94171","94172","94175","94177","94188","94199","94301","94302","94303","94304","94305","94306","94307","94308","94309","94310","94401","94402","94403","94404","94405","94406","94407","94408","94409","94497","94501","94502","94503","94506","94507","94510","94516","94517","94518","94519","94520","94521","94522","94523","94524","94525","94526","94527","94528","94529","94530","94536","94537","94538","94539","94540","94541","94542","94543","94544","94545","94546","94547","94549","94552","94553","94555","94556","94557","94559","94560","94563","94564","94565","94566","94568","94569","94570","94572","94575","94577","94578","94579","94580","94582","94583","94586","94587","94588","94589","94590","94591","94592","94595","94596","94597","94598","94601","94602","94603","94604","94605","94606","94607","94608","94609","94610","94611","94612","94613","94614","94615","94617","94618","94619","94620","94621","94622","94623","94624","94625","94626","94627","94643","94649","94659","94660","94661","94662","94666","94701","94702","94703","94704","94705","94706","94707","94708","94709","94710","94712","94720","94801","94802","94803","94804","94805","94806","94807","94808","94820","94850","94901","94903","94904","94912","94913","94914","94915","94920","94924","94925","94930","94933","94938","94939","94941","94942","94945","94946","94947","94948","94949","94950","94952","94953","94954","94955","94956","94957","94960","94963","94964","94965","94966","94970","94973","94974","94975","94976","94977","94978","94979","94998","94999","95002","95476"];

  function getCityByZip(zip) {
    var z = String(zip).replace(/\D/g, '').slice(0, 5);
    if (z.length < 5) return null;
    if (LA_ZIPS.indexOf(z) >= 0) return 'los_angeles';
    if (HONOLULU_ZIPS.indexOf(z) >= 0) return 'honolulu';
    if (SF_ZIPS.indexOf(z) >= 0) return 'san_francisco';
    if (VENTURA_ZIPS.indexOf(z) >= 0) return 'ventura';
    if (OC_ZIPS.indexOf(z) >= 0) return 'orange_county';
    if (IE_ZIPS.indexOf(z) >= 0) return 'inland_empire';
    return 'other';
  }

  /** Cookie/cart may have full (los_angeles) or short (la) — always return la|sf|hnl or null */
  function cityToRegion(city) {
    var c = (city || '').toLowerCase().trim();
    if (c === 'los_angeles' || c === 'la') return 'la';
    if (c === 'san_francisco' || c === 'sf') return 'sf';
    if (c === 'honolulu' || c === 'hnl') return 'hnl';
    if (c === 'ventura' || c === 'vc') return 'la'; // VC shares the LA catalog since 2026-07-05 (clones drafted)
    if (c === 'orange_county' || c === 'oc') return 'la'; // OC shares the LA catalog (no -oc clones)
    if (c === 'inland_empire' || c === 'ie') return 'la'; // IE shares the LA catalog (no clones)
    return null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;expires=' + d.toUTCString() + ';SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  /** Map URL slug (query value, param name, path segment, hash) → canonical store city id */
  function slugToCity(slug) {
    var c = String(slug || '').toLowerCase().trim();
    if (!c) return null;
    if (c === 'honolulu' || c === 'hnl') return 'honolulu';
    if (c === 'san_francisco' || c === 'sf' || c === 'san-francisco' || c === 'sanfrancisco') return 'san_francisco';
    if (c === 'los_angeles' || c === 'la' || c === 'los-angeles' || c === 'losangeles') return 'los_angeles';
    if (c === 'ventura' || c === 'vc' || c === 'ventura-county' || c === 'ventura_county') return 'ventura';
    if (c === 'orange_county' || c === 'oc' || c === 'orange-county' || c === 'orangecounty') return 'orange_county';
    if (c === 'inland_empire' || c === 'ie' || c === 'inland-empire' || c === 'inlandempire') return 'inland_empire';
    return null;
  }

  /** Canonical home URL: ?city=… (LA остаётся чистым «/») */
  function homeUrlWithCityQuery(city) {
    if (city === 'los_angeles') return '/';
    if (city === 'honolulu') return '/?city=honolulu';
    if (city === 'san_francisco') return '/?city=san_francisco';
    if (city === 'ventura') return '/?city=ventura';
    if (city === 'orange_county') return '/?city=orange_county';
    if (city === 'inland_empire') return '/?city=inland_empire';
    return '/';
  }

  /**
   * Parse city from URL (in order):
   * - ?city= (канон, как раньше)
   * - Hash #honolulu (старые ссылки / return_to)
   * - Pretty query: город как имя параметра
   * - Path: /honolulu
   */
  function getCityFromUrl() {
    var params = typeof URLSearchParams !== 'undefined' && window.location.search ? new URLSearchParams(window.location.search) : null;
    if (params && params.has('city')) {
      var fromCityParam = slugToCity(params.get('city'));
      if (fromCityParam) return fromCityParam;
    }
    var hash = (window.location.hash || '').replace(/^#/, '').split(/[?&]/)[0];
    if (hash) {
      var fromHash = slugToCity(decodeURIComponent(hash));
      if (fromHash) return fromHash;
    }
    if (params) {
      var keys = [];
      params.forEach(function (_v, k) {
        keys.push(k);
      });
      var i;
      for (i = 0; i < keys.length; i++) {
        var fromKey = slugToCity(keys[i]);
        if (fromKey) return fromKey;
      }
    }
    var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    if (path !== '/' && path.indexOf('/') === 0) {
      var segments = path.slice(1).split('/').filter(Boolean);
      if (segments.length === 1) {
        var fromPath = slugToCity(segments[0]);
        if (fromPath) return fromPath;
      }
    }
    return null;
  }

  /** City for rewriting: cookie, then URL (?city= / hash / path / pretty), then cart, then body */
  function getCityForRewrite() {
    var city = getCookie(COOKIE_NAME);
    if (city) return city;
    city = getCityFromUrl();
    if (city) return city;
    var fromCart = typeof window.__STORE_CITY_FROM_CART__ !== 'undefined' && window.__STORE_CITY_FROM_CART__;
    if (fromCart && String(fromCart).trim()) return String(fromCart).trim();
    var bodyCity = document.body.getAttribute(BODY_ATTR);
    if (bodyCity && /^(la|sf|hnl|vc|oc|ie|los_angeles|san_francisco|honolulu|ventura|orange_county|inland_empire)$/i.test(bodyCity)) return bodyCity;
    return null;
  }

  function isHomePath() {
    var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    if (path === '' || path === '/' || path === '/index' || path === '/pages/index') return true;
    if (path.indexOf('/') === 0 && path.length > 1) {
      var segments = path.slice(1).split('/').filter(Boolean);
      if (segments.length === 1 && slugToCity(segments[0])) return true;
    }
    return false;
  }

  function getCityDisplayName(city) {
    if (!city) return 'Change Location';
    var c = String(city).toLowerCase();
    if (c === 'los_angeles' || c === 'la') return 'Los Angeles County';
    if (c === 'san_francisco' || c === 'sf') return 'San Francisco Bay Area';
    if (c === 'honolulu' || c === 'hnl') return 'Honolulu (Oahu)';
    if (c === 'ventura' || c === 'vc') return 'Ventura County';
    if (c === 'orange_county' || c === 'oc') return 'Orange County';
    if (c === 'inland_empire' || c === 'ie') return 'Inland Empire';
    return 'Change Location';
  }


  /* ---- Smart search: city names + addresses (2026-07-05) ---- */
  var SF_CITY_NAMES = ["San Francisco","Oakland","Berkeley","Alameda","Emeryville","Richmond","El Cerrito","Daly City","South San Francisco","San Bruno","Millbrae","Burlingame","San Mateo","Foster City","Belmont","San Carlos","Redwood City","Menlo Park","Palo Alto","Mountain View","Sunnyvale","Pacifica","Half Moon Bay","Hayward","Castro Valley","San Leandro","Fremont","Union City","Walnut Creek","Concord","Lafayette","Danville","San Ramon","Dublin","Pleasanton","Livermore","Vallejo","Napa","Sonoma","San Rafael","Mill Valley","Sausalito","Novato","Bay Area"];
  var CITY_INDEX = null;
  function normName(s) {
    return String(s || '').toLowerCase().replace(/[\u00e0-\u00e5]/g, 'a').replace(/\u00e7/g, 'c').replace(/[\u00e8-\u00eb]/g, 'e').replace(/[\u00f1]/g, 'n').replace(/\s+/g, ' ').trim();
  }
  function buildCityIndex() {
    if (CITY_INDEX) return CITY_INDEX;
    CITY_INDEX = {};
    for (var z in ZIP_LOCAL_NAMES) {
      var name = ZIP_LOCAL_NAMES[z];
      var region = getCityByZip(z);
      if (!region || region === 'other') continue;
      if (!CITY_INDEX[name]) CITY_INDEX[name] = { region: region, zip: z, n: normName(name) };
    }
    for (var i = 0; i < SF_CITY_NAMES.length; i++) {
      var nm = SF_CITY_NAMES[i];
      if (!CITY_INDEX[nm]) CITY_INDEX[nm] = { region: 'san_francisco', zip: null, n: normName(nm) };
    }
    var extras = { 'Los Angeles': ['los_angeles', '90012'], 'Orange County': ['orange_county', '92618'], 'Inland Empire': ['inland_empire', '91764'], 'Oahu': ['honolulu', '96813'] };
    for (var e in extras) {
      if (!CITY_INDEX[e]) CITY_INDEX[e] = { region: extras[e][0], zip: extras[e][1], n: normName(e) };
    }
    return CITY_INDEX;
  }
  /** typing mode: prefix matches first, then substring; resolve mode: city name contained in query (addresses) */
  function findCityMatches(query, resolveMode) {
    var idx = buildCityIndex();
    var q = normName(query);
    if (q.length < 2) return [];
    var starts = [], contains = [];
    for (var name in idx) {
      var e = idx[name];
      if (resolveMode) {
        if (q === e.n || q.indexOf(e.n) >= 0) contains.push({ name: name, region: e.region, zip: e.zip, len: e.n.length });
        else if (e.n.indexOf(q) === 0) starts.push({ name: name, region: e.region, zip: e.zip, len: e.n.length });
      } else {
        if (e.n.indexOf(q) === 0) starts.push({ name: name, region: e.region, zip: e.zip, len: e.n.length });
        else if (e.n.indexOf(q) >= 0) contains.push({ name: name, region: e.region, zip: e.zip, len: e.n.length });
      }
    }
    if (resolveMode) {
      contains.sort(function (a, b) { return b.len - a.len; });
      return contains.length ? contains : starts;
    }
    starts.sort(function (a, b) { return a.name.length - b.name.length; });
    contains.sort(function (a, b) { return a.name.length - b.name.length; });
    return starts.concat(contains).slice(0, 6);
  }
  /** ZIP anywhere in string, else city name (longest wins). Returns {city, zip} or {error} */
  function smartResolve(qRaw) {
    var q = String(qRaw || '').trim();
    if (!q) return { error: 'Please enter your ZIP code, city or address.' };
    var zm = q.match(/\b(\d{5})\b/);
    if (zm) {
      var c = getCityByZip(zm[1]);
      if (c && c !== 'other') return { city: c, zip: zm[1] };
    }
    var matches = findCityMatches(q, true);
    if (matches.length) return { city: matches[0].region, zip: matches[0].zip };
    if (zm) return { error: "Sorry, we don't deliver to " + zm[1] + ' yet.' };
    return { error: "We couldn't find that city \u2014 try entering your ZIP code." };
  }

  function updateTriggerLabel(city) {
    var label = getCityDisplayName(city);
    var trigger = document.getElementById('zip-popup-trigger');
    if (trigger) {
      var textEl = trigger.querySelector('.zip-popup-trigger-text');
      if (textEl) textEl.textContent = label;
      trigger.setAttribute('aria-label', label);
      trigger.setAttribute('title', label);
    }
    document.querySelectorAll('.gh-actions__location-btn[data-open-zip-popup]').forEach(function (el) {
      el.setAttribute('aria-label', label);
      el.setAttribute('title', label);
    });
  }

  /** Strip -la, -sf, -hnl or trailing hyphen from handle to get base handle (theme may output "harmony-") */
  function getHandleBase(handle) {
    if (!handle || typeof handle !== 'string') return '';
    var base = handle.replace(/-la$|-sf$|-hnl$|-vc$/i, '').trim();
    base = base.replace(/-+$/, ''); // trim trailing hyphen(s) so "harmony-" -> "harmony"
    return base;
  }

  /** Get region from handle for filtering: la, sf, hnl, or base */
  function getRegionFromHandle(handle) {
    if (!handle || typeof handle !== 'string') return 'base';
    var h = handle.toLowerCase().replace(/-+$/, '').trim();
    if (h.length >= 3 && h.slice(-3) === '-la') return 'la';
    if (h.length >= 3 && h.slice(-3) === '-sf') return 'sf';
    if (h.length >= 4 && h.slice(-4) === '-hnl') return 'hnl';
    if (h.length >= 3 && h.slice(-3) === '-vc') return 'vc';
    return 'base';
  }

  function getHandleFromHref(href) {
    if (!href) return '';
    var m = href.match(/\/(?:collections|products)\/([^/?]+)/);
    return m ? m[1] : '';
  }

  /** LA uses base handles (no -la); treat base as matching when filter is la. SF/HNL use -sf/-hnl only. */
  function regionMatchesFilter(region, cardRegion) {
    if (!region) return true;
    if (cardRegion === region) return true;
    if (region === 'la' && cardRegion === 'base') return true;
    return false;
  }

  /** Search UI + product page recommendations («BUY WITH») — same duplicate filter as predictive search. */
  function inRegionDuplicateFilterContext(el) {
    var searchContainers = document.querySelectorAll('.predictive-search, .search-modal, [class*="predictive"], [class*="search-modal"], #Search-In-Modal');
    var i;
    for (i = 0; i < searchContainers.length; i++) {
      if (searchContainers[i].contains(el)) return true;
    }
    var mainEl = document.querySelector('main');
    var isSearchPage = window.location.pathname === '/search' || (mainEl && mainEl.classList && mainEl.classList.contains('search'));
    if (isSearchPage && mainEl && mainEl.contains(el)) return true;
    if (window.location.pathname.indexOf('/collections/') === 0 && mainEl && mainEl.contains(el)) {
      // NEVER dedup the main collection product grid — a collection page must show exactly its
      // curated products to every visitor (any region). Dedup here was emptying base + regional
      // grids for non-LA visitors. Other blocks on the page (search/recs) still dedup.
      if (el.closest && el.closest('#product-grid, #ProductGridContainer')) return false;
      return true;
    }
    if (el.closest && el.closest('#product-grid, [id^="product-grid"], [class*="collection-list"], .collection')) return true;
    if (el.closest && el.closest('[class*="featured-collection"]')) {
      var __isHome = (window.location.pathname === '/' || window.location.pathname === '');
      return !__isHome; // homepage featured-collection (base-only bestsellers) must NOT be region-hidden
    }
    // recommendations / related / complementary sections are NOT region-deduped — keep recommended cards visible (fixes orphan "BUY WITH")
    return false;
  }

  /** Mark product/collection links and card parents with data-region so we can hide duplicates in search.
   * Use original href (before rewrite) when present, so each card keeps its real region (la/sf/hnl/base). */
  function markRegionOnLinks() {
    var links = document.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]');
    var cardSel = '[class*="card"], [class*="product"], [class*="search"], [class*="predictive"], .grid__item, .list-view-item, li';
    links.forEach(function (link) {
      if (link.closest('#zip-code-popup')) return;
      var href = link.getAttribute(ORIGINAL_HREF) || link.getAttribute('href') || '';
      var handle = getHandleFromHref(href);
      var r = getRegionFromHandle(handle);
      var base = getHandleBase(handle);
      link.setAttribute(DATA_REGION, r);
      link.setAttribute('data-region-base', base);
      var parent = link.closest(cardSel);
      if (parent && parent !== link) { parent.setAttribute(DATA_REGION, r); parent.setAttribute('data-region-base', base); }
      var li = link.closest('li');
      if (li) { li.setAttribute(DATA_REGION, r); li.setAttribute('data-region-base', base); }
    });
  }

  /** In search + recommendations: hide cards that are not for the selected region */
  function isRegionalCollectionPage() {
    return /\/collections\/[^\/]*-(?:vc|hnl|sf)(?:\/|$)/.test(window.location.pathname);
  }
  function hideDuplicateCards(region) {
    markRegionOnLinks();
    region = region || 'la';
    if (isRegionalCollectionPage()) return; // products already correct region -> never hide the grid
    var regionClones = {};
    if (region !== 'la') {
      document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
        if (!inRegionDuplicateFilterContext(el)) return;
        if (el.getAttribute(DATA_REGION) === region) {
          var b = el.getAttribute('data-region-base');
          if (b) regionClones[b] = true;
        }
      });
    }
    document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
      if (!inRegionDuplicateFilterContext(el)) return;
      var r = el.getAttribute(DATA_REGION);
      var show;
      if (region === 'la') {
        show = (r === 'la' || r === 'base');
      } else if (r === region) {
        show = true;
      } else if (r === 'base' || r === 'la') {
        var b = el.getAttribute('data-region-base');
        show = !(b && regionClones[b]);
      } else {
        show = false;
      }
      el.style.display = show ? '' : 'none';
    });
  }

  function showAllSearchCards() {
    markRegionOnLinks();
    document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
      if (inRegionDuplicateFilterContext(el)) el.style.display = '';
    });
  }

  /** Rewrite one link to point to region version.
   * Rules:
   * - LA: use base handle (no suffix) because base products already exist
   * - SF/HNL: use duplicated handles (-sf / -hnl)
   */
  function rewriteLink(link, region) {
    if (!region || String(region).length === 0) return; // never rewrite with empty region (would make "harmony-")
    if (isRegionalCollectionPage() && link.closest('#product-grid, #ProductGridContainer')) return; // keep regional collection grid links intact
    var href = link.getAttribute('href');
    if (!href || (href.indexOf('/collections/') < 0 && href.indexOf('/products/') < 0)) return;
    if (link.closest('#zip-code-popup')) return;

    var match = href.match(/^(\/(?:collections|products)\/)([^/?]+)([^]*)$/);
    if (!match) return;
    var prefix = match[1];
    var handle = match[2];
    var rest = match[3];
    var base = getHandleBase(handle);
    if (!base) return;

    var newHandle = region === 'la' ? base : (base + '-' + region);
    if (newHandle === handle) return;

    // PCREGION FALLBACK: for collection links, only rewrite when the regional twin resolves.
    if (region !== 'la' && prefix.indexOf('collections') >= 0) {
      var wl = PC_TWIN_COLL[region];
      if (wl && !wl[newHandle]) return; // no twin/redirect -> keep base link, never 404
    }

    var isBrokenHandle = (handle.slice(-1) === '-' && !/-(?:la|sf|hnl|vc)$/i.test(handle));
    if (!link.getAttribute(ORIGINAL_HREF) && !isBrokenHandle) {
      link.setAttribute(ORIGINAL_HREF, href);
    }
    link.setAttribute('href', prefix + newHandle + rest);
    link.setAttribute(REWRITTEN_ATTR, region);
  }

  // Pricing note:
  // We no longer adjust prices via JavaScript.
  // Each city has its own duplicated products with correct prices in Shopify,
  // so we keep theme-rendered prices as-is.
  function applyPrices() {}

  function stripCitySuffix(text) {
    if (!text) return text;
    return String(text).replace(/\s*-\s*(Los Angeles|San Francisco|Honolulu|Ventura County)\s*$/i, '').trim();
  }

  /** Hide city suffix in product titles across site (cards, predictive search, etc.). */
  function hideCityNamesInTitles() {
    var nodes = document.querySelectorAll(
      [
        '.card__heading a.full-unstyled-link',
        '.card__heading a',
        '.predictive-search__list-item a',
        '[id^="predictive-search-option-product-"] a',
        'a.full-unstyled-link'
      ].join(',')
    );

    nodes.forEach(function (el) {
      if (el.closest('#zip-code-popup')) return;
      if (el.classList && (el.classList.contains('zip-popup-city-btn') || el.classList.contains('zip-popup-trigger'))) return;

      // Don't destroy markup / links: only update plain-text elements.
      if (el.querySelector && el.querySelector('*')) return;

      var t = el.textContent;
      var cleaned = stripCitySuffix(t);
      if (cleaned !== t) el.textContent = cleaned;
    });
  }

  /** Restore link to original href (when region is "other"). Never restore to broken "handle-" URL. */
  function restoreLink(link) {
    var orig = link.getAttribute(ORIGINAL_HREF);
    if (!orig) return;
    var handleMatch = orig.match(/\/(?:collections|products)\/([^/?]+)/);
    if (handleMatch && handleMatch[1].slice(-1) === '-' && !/-(?:la|sf|hnl|vc)$/i.test(handleMatch[1])) return;
    link.setAttribute('href', orig);
    link.removeAttribute(ORIGINAL_HREF);
    link.removeAttribute(REWRITTEN_ATTR);
  }

  /** Rewrite all collection/product links to current region, or restore if region is other */
  function rewriteLinksToRegion(region) {
    var links = document.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]');
    links.forEach(function (link) {
      if (link.closest('#zip-code-popup')) return;
      if (region) {
        rewriteLink(link, region);
      } else {
        restoreLink(link);
      }
    });
  }

  function applyRegion(city) {
    var region = cityToRegion(city);
    document.body.setAttribute(BODY_ATTR, region || 'other');
    document.body.classList.remove('store-city-la', 'store-city-sf', 'store-city-hnl', 'store-city-other');
    document.body.classList.add('store-city-' + (region || 'other'));
    rewriteLinksToRegion(region);
    hideDuplicateCards(region || 'la');
    applyPrices(city);
    hideCityNamesInTitles();
  }

  function runPopup() {
    var popup = document.getElementById('zip-code-popup');
    var input = document.getElementById('zip-code-input');
    var btn = document.getElementById('zip-code-submit');
    var err = document.getElementById('zip-code-error');
    if (!popup || !input || !btn) return;

    function closePopup() {
      popup.classList.remove('zip-popup--open');
      document.body.classList.remove('zip-popup-open');
    }

    function openPopup() {
      popup.classList.add('zip-popup--open');
      document.body.classList.add('zip-popup-open');
    }

    function applyCity(city) {
      setCookie(COOKIE_NAME, city, COOKIE_DAYS);
      closePopup();
      if (typeof window.zipCityApplied === 'function') window.zipCityApplied(city);
      redirectWithCitySaved(city);
    }

    function getReturnToUrlForCity(city) {
      if (isHomePath()) {
        return homeUrlWithCityQuery(city);
      }
      return window.location.pathname + (window.location.search || '') + (window.location.hash || '');
    }

    function redirectWithCitySaved(city) {
      // IMPORTANT:
      // Liquid can only read the selected city from cart.attributes.
      // Using /cart/update?...&return_to=... guarantees attributes are persisted BEFORE the next page render.
      var shortCity = city === 'los_angeles' ? 'la' : (city === 'san_francisco' ? 'sf' : (city === 'honolulu' ? 'hnl' : (city === 'ventura' ? 'vc' : (city === 'orange_county' ? 'oc' : (city === 'inland_empire' ? 'ie' : 'other')))));
      var returnTo = getReturnToUrlForCity(city);

      // Build query string without relying on URLSearchParams (older browsers).
      var qs =
        'attributes%5Bstore_city%5D=' + encodeURIComponent(city) +
        '&attributes%5Bselected_city%5D=' + encodeURIComponent(shortCity) +
        '&return_to=' + encodeURIComponent(returnTo);

      window.location.href = '/cart/update?' + qs;
    }

    function saveCityToCart(city) {
      var attr = { store_city: city };
      var shortCity = city === 'los_angeles' ? 'la' : (city === 'san_francisco' ? 'sf' : (city === 'honolulu' ? 'hnl' : (city === 'ventura' ? 'vc' : (city === 'orange_county' ? 'oc' : (city === 'inland_empire' ? 'ie' : 'other')))));
      attr.selected_city = shortCity;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attr })
      }).catch(function () {});
    }

    function pickResult(city, zip) {
      if (zip) localStorage.setItem('pc_selected_zip', zip);
      err && (err.textContent = '');
      applyCity(city);
    }
    btn.addEventListener('click', function () {
      err && (err.textContent = '');
      var res = smartResolve(input.value);
      if (res.error) { err && (err.textContent = res.error); return; }
      pickResult(res.city, res.zip);
    });
    var results = document.getElementById('zip-search-results');
    /* Google Places address autocomplete (2026-07-05). Key is domain-restricted to Places API only. */
    var PLACES_KEY = 'AIzaSyCyr_9h6iCIYQPfsLRZG-iOrPiMv7LjGU8';
    var placesSession = null, placesTimer = null, placesRows = [], placesQuery = '';
    function uuid4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
    function looksLikeAddress(q) {
      var t = String(q || '').trim();
      return /\d/.test(t) && /[a-z]/i.test(t) && t.length >= 6;
    }
    function fetchAddressSuggestions(q) {
      if (!window.fetch) return;
      if (!placesSession) placesSession = uuid4();
      fetch('https://places.googleapis.com/v1/places:autocomplete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Goog-Api-Key': PLACES_KEY },
        body: JSON.stringify({ input: q, includedRegionCodes: ['US'], sessionToken: placesSession })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if ((input.value || '').trim() !== q) return; /* stale response */
        placesQuery = q;
        placesRows = [];
        var sugg = d.suggestions || [];
        for (var i = 0; i < sugg.length && placesRows.length < 4; i++) {
          var p = sugg[i].placePrediction;
          if (p && p.placeId) placesRows.push({ label: (p.text && p.text.text) || '', placeId: p.placeId });
        }
        paintRows();
      }).catch(function () {});
    }
    function resolvePlace(placeId) {
      var sess = placesSession;
      placesSession = null; /* session ends with the details call */
      err && (err.textContent = '');
      fetch('https://places.googleapis.com/v1/places/' + encodeURIComponent(placeId) + (sess ? '?sessionToken=' + encodeURIComponent(sess) : ''), {
        headers: { 'X-Goog-Api-Key': PLACES_KEY, 'X-Goog-FieldMask': 'addressComponents' }
      }).then(function (r) { return r.json(); }).then(function (d) {
        var zip = null, comps = d.addressComponents || [];
        for (var i = 0; i < comps.length; i++) {
          if ((comps[i].types || []).indexOf('postal_code') >= 0) { zip = comps[i].longText || comps[i].shortText; break; }
        }
        var region = zip ? getCityByZip(zip) : null;
        if (region && region !== 'other') {
          pickResult(region, zip);
        } else if (zip) {
          err && (err.textContent = "Sorry, we don't deliver to " + zip + ' yet.');
        } else {
          err && (err.textContent = "We couldn't confirm this address — try your ZIP code.");
        }
      }).catch(function () {
        err && (err.textContent = 'Address check failed — try your ZIP code.');
      });
    }
    var localRows = [];
    function paintRows() {
      if (!results) return;
      var q = (input.value || '').trim();
      var html = '';
      for (var r = 0; r < localRows.length; r++) {
        var row = localRows[r];
        if (row.ok) {
          html += '<div class="zip-search-opt" data-region="' + row.region + '" data-zip="' + (row.zip || '') + '"><span>' + escapeHtml(row.label) + '</span><span class="zip-search-ok">✓ We deliver here</span></div>';
        } else {
          html += '<div class="zip-search-opt zip-search-no"><span>' + escapeHtml(row.label) + '</span><span class="zip-search-nope">✗ Not in our delivery area yet</span></div>';
        }
      }
      if (placesQuery === q) {
        for (var a = 0; a < placesRows.length; a++) {
          html += '<div class="zip-search-opt zip-search-addr" data-place-id="' + escapeHtml(placesRows[a].placeId) + '"><span>📍 ' + escapeHtml(placesRows[a].label) + '</span><span class="zip-search-check">check ›</span></div>';
        }
      }
      if (!html) { results.style.display = 'none'; results.innerHTML = ''; return; }
      results.innerHTML = html;
      results.style.display = 'block';
    }
    function renderResults() {
      var q = (input.value || '').trim();
      localRows = [];
      var zm = q.match(/\b(\d{5})\b/);
      if (zm) {
        var zc = getCityByZip(zm[1]);
        if (zc && zc !== 'other') {
          localRows.push({ label: 'ZIP ' + zm[1] + ' — ' + getCityDisplayName(zc), ok: true, region: zc, zip: zm[1] });
        } else {
          var cm0 = findCityMatches(q, true).slice(0, 3);
          for (var m0 = 0; m0 < cm0.length; m0++) {
            localRows.push({ label: cm0[m0].name + ' — ' + getCityDisplayName(cm0[m0].region), ok: true, region: cm0[m0].region, zip: cm0[m0].zip });
          }
          if (!cm0.length && !looksLikeAddress(q)) localRows.push({ label: 'ZIP ' + zm[1], ok: false });
        }
      } else if (q.length >= 2 && !/^\d+$/.test(q)) {
        var ms = findCityMatches(q, false);
        if (!ms.length) ms = findCityMatches(q, true).slice(0, 3);
        for (var i = 0; i < ms.length && i < 4; i++) {
          localRows.push({ label: ms[i].name + ' — ' + getCityDisplayName(ms[i].region), ok: true, region: ms[i].region, zip: ms[i].zip });
        }
      }
      if (placesQuery !== q) placesRows = [];
      paintRows();
      if (placesTimer) clearTimeout(placesTimer);
      if (looksLikeAddress(q)) {
        placesTimer = setTimeout(function () { fetchAddressSuggestions(q); }, 300);
      }
    }
    if (results) {
      input.addEventListener('input', renderResults);
      results.addEventListener('click', function (e) {
        var opt = e.target.closest ? e.target.closest('.zip-search-opt') : null;
        if (!opt) return;
        var pid = opt.getAttribute('data-place-id');
        if (pid) { resolvePlace(pid); return; }
        if (opt.getAttribute('data-region')) pickResult(opt.getAttribute('data-region'), opt.getAttribute('data-zip') || null);
      });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') btn.click();
    });

    popup.querySelectorAll('.zip-popup-close').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    popup.querySelectorAll('.zip-popup-city-btn').forEach(function (el) {
      el.addEventListener('click', function () {
        var city = el.getAttribute('data-city');
        if (city) { err && (err.textContent = ''); applyCity(city); }
      });
    });

    document.querySelectorAll('[data-open-zip-popup], #zip-popup-trigger').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openPopup(); });
    });

    var saved = getCityForRewrite();
    if (saved && cityToRegion(saved)) {
      if (!getCookie(COOKIE_NAME) && getCityFromUrl()) setCookie(COOKIE_NAME, saved, COOKIE_DAYS);
      closePopup();
      applyRegion(saved);
      // Best-effort sync for future server-side renders (no redirect here).
      if (getCookie(COOKIE_NAME)) saveCityToCart(saved);
      updateTriggerLabel(saved);
      if (isHomePath()) {
        if (saved === 'los_angeles' && (window.location.search || window.location.hash)) {
          history.replaceState(null, '', '/');
        } else if (saved === 'honolulu' || saved === 'san_francisco' || saved === 'ventura' || saved === 'orange_county' || saved === 'inland_empire') {
          var prettyHome = homeUrlWithCityQuery(saved);
          var normPath = (window.location.pathname || '/').replace(/\/$/, '') || '/';
          var params = typeof URLSearchParams !== 'undefined' && window.location.search ? new URLSearchParams(window.location.search) : null;
          var fromQuery = params ? slugToCity(params.get('city')) : null;
          var hashSeg = (window.location.hash || '').replace(/^#/, '').split(/[?&]/)[0];
          var fromHash = hashSeg ? slugToCity(decodeURIComponent(hashSeg)) : null;
          var queryOk = fromQuery === saved;
          var pathOk = normPath === '/' || normPath === '';
          if (!pathOk || !queryOk || fromHash || window.location.hash) {
            history.replaceState(null, '', prettyHome);
          }
        }
      }
    } else {
      if (isHomePath()) {
        setTimeout(function () { openPopup(); }, 3000);
      } else {
        openPopup();
      }
    }

    var trigger = document.getElementById('zip-popup-trigger');
    if (trigger) {
      var searchEl = document.querySelector('.global-header .header__search, header .header__search, .header__search, [class*="global-header"] details-modal, [class*="header"] [class*="search"]');
      var iconsWrap = document.querySelector('.header__icons, .header-icons, [class*="global-header"] .header__icons');
      var ghActions = document.querySelector('.global-header .gh-actions, [class*="global-header"] .gh-actions');
      if (ghActions && ghActions.parentNode) {
        ghActions.insertBefore(trigger, ghActions.firstChild);
        trigger.classList.add('gh-inline');
      } else if (iconsWrap) {
        iconsWrap.insertBefore(trigger, iconsWrap.firstChild);
        trigger.classList.add('gh-inline');
      } else if (searchEl && searchEl.parentNode) {
        if (searchEl.nextSibling) {
          searchEl.parentNode.insertBefore(trigger, searchEl.nextSibling);
        } else {
          searchEl.parentNode.appendChild(trigger);
        }
        trigger.classList.add('gh-inline');
      }
      (function () {
        function isLightBg(el) {
          if (!el) return false;
          var style = window.getComputedStyle(el);
          var bg = style.backgroundColor;
          var opacity = parseFloat(style.opacity);
          if (bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') {
            var parent = el.parentElement;
            return parent ? isLightBg(parent) : false;
          }
          var m = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
          if (m) {
            var r = parseInt(m[1], 10), g = parseInt(m[2], 10), b = parseInt(m[3], 10);
            return (r * 0.299 + g * 0.587 + b * 0.114) > 200;
          }
          if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(bg)) {
            var hex = bg.slice(1).length === 3 ? bg.slice(1).replace(/./g, '$&$&') : bg.slice(1);
            var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
            return (r * 0.299 + g * 0.587 + b * 0.114) > 200;
          }
          return false;
        }
        function updateTriggerLightBg() {
          if (!trigger || !trigger.classList.contains('gh-inline')) return;
          var header = trigger.closest('header, [class*="header"], [class*="Header"]');
          if (isLightBg(header || trigger.parentElement)) {
            trigger.classList.add('light-bg');
          } else {
            trigger.classList.remove('light-bg');
          }
        }
        updateTriggerLightBg();
        var scrollT = 0;
        window.addEventListener('scroll', function () {
          if (scrollT) clearTimeout(scrollT);
          scrollT = setTimeout(function () {
            scrollT = null;
            updateTriggerLightBg();
          }, 80);
        }, { passive: true });
      })();
    }

    window.openZipPopup = openPopup;
  }

  var rewriteDebounceTimer;
  function scheduleRewriteForNewContent() {
    if (rewriteDebounceTimer) clearTimeout(rewriteDebounceTimer);
    rewriteDebounceTimer = setTimeout(function () {
      rewriteDebounceTimer = null;
      var city = getCityForRewrite();
      if (city) applyRegion(city);
      else hideDuplicateCards('la');
      hideCityNamesInTitles();
    }, 150);
  }

  function observeDynamicContent() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var list = mutations[i].addedNodes;
        for (var j = 0; j < list.length; j++) {
          var node = list[j];
          if (node.nodeType !== 1) continue;
          if (node.querySelector && (node.querySelector('a[href*="/products/"]') || node.querySelector('a[href*="/collections/"]'))) {
            scheduleRewriteForNewContent();
            break;
          }
          if (node.getAttribute && node.getAttribute('href') && (node.getAttribute('href').indexOf('/products/') >= 0 || node.getAttribute('href').indexOf('/collections/') >= 0)) {
            scheduleRewriteForNewContent();
            break;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    runPopup();
    observeDynamicContent();
    var _c = getCityForRewrite();
    hideDuplicateCards((_c && cityToRegion(_c)) || 'la');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.getZipCity = getCookie.bind(null, COOKIE_NAME);
  window.getCityByZip = getCityByZip;
  window.cityToRegion = cityToRegion;
  window.applyRegion = applyRegion;
  window.applyPrices = applyPrices;
  window.rewriteLinksToRegion = rewriteLinksToRegion;
  // Backwards compat: some older code referenced this symbol.
  window.adjustPriceForNonLA = function () {};

  // === LOCAL HEADING BY ZIP CODE ===
  var ZIP_LOCAL_NAMES = {
    // SF Bay Area neighborhoods
    '94701': 'Berkeley', '94702': 'Berkeley', '94703': 'Berkeley', '94704': 'Berkeley',
    '94705': 'Berkeley', '94706': 'Albany', '94707': 'Berkeley', '94708': 'Berkeley',
    '94709': 'Berkeley', '94710': 'Berkeley', '94720': 'Berkeley',
    '94601': 'Oakland', '94602': 'Oakland', '94603': 'Oakland', '94604': 'Oakland',
    '94605': 'Oakland', '94606': 'Oakland', '94607': 'Oakland', '94608': 'Emeryville',
    '94609': 'Oakland', '94610': 'Oakland', '94611': 'Oakland', '94612': 'Oakland',
    '94613': 'Oakland', '94614': 'Oakland', '94615': 'Oakland', '94618': 'Oakland',
    '94619': 'Oakland', '94621': 'Oakland', '94622': 'Oakland', '94623': 'Oakland',
    '94624': 'Oakland', '94625': 'Oakland', '94649': 'Oakland', '94660': 'Oakland',
    '94661': 'Oakland', '94662': 'Oakland',
    '94501': 'Alameda', '94502': 'Alameda',
    '94801': 'Richmond', '94802': 'Richmond', '94803': 'El Sobrante',
    '94804': 'Richmond', '94805': 'Richmond', '94806': 'San Pablo', '94820': 'El Cerrito',
    '94530': 'El Cerrito',
    '94577': 'San Leandro', '94578': 'San Leandro', '94579': 'San Leandro',
    '94580': 'San Lorenzo',
    '94541': 'Hayward', '94542': 'Hayward', '94544': 'Hayward', '94545': 'Hayward',
    '94546': 'Castro Valley', '94552': 'Castro Valley',
    '94555': 'Fremont',
    '94507': 'Alamo', '94526': 'Danville', '94528': 'Danville',
    '94549': 'Lafayette', '94556': 'Moraga', '94563': 'Orinda',
    '94595': 'Walnut Creek', '94596': 'Walnut Creek', '94597': 'Walnut Creek', '94598': 'Walnut Creek',
    '94518': 'Concord', '94523': 'Pleasant Hill', '94553': 'Martinez',
    '94901': 'San Rafael', '94903': 'San Rafael', '94904': 'Greenbrae',
    '94920': 'Tiburon', '94925': 'Corte Madera', '94939': 'Larkspur',
    '94941': 'Mill Valley', '94960': 'San Anselmo', '94965': 'Sausalito',
    '94014': 'Daly City', '94015': 'Daly City', '94016': 'Daly City',
    '94080': 'South San Francisco', '94083': 'South San Francisco',
    '94044': 'Pacifica', '94066': 'San Bruno', '94030': 'Millbrae',
    '94010': 'Burlingame', '94401': 'San Mateo', '94402': 'San Mateo',
    '94403': 'San Mateo', '94404': 'Foster City',
    '94002': 'Belmont', '94070': 'San Carlos', '94065': 'Redwood Shores',
    '94061': 'Redwood City', '94062': 'Redwood City', '94063': 'Redwood City',
    '94028': 'Portola Valley',
    // SF proper
    '94102': 'San Francisco', '94103': 'San Francisco', '94104': 'San Francisco',
    '94105': 'San Francisco', '94107': 'San Francisco', '94108': 'San Francisco',
    '94109': 'San Francisco', '94110': 'San Francisco', '94111': 'San Francisco',
    '94112': 'San Francisco', '94114': 'San Francisco', '94115': 'San Francisco',
    '94116': 'San Francisco', '94117': 'San Francisco', '94118': 'San Francisco',
    '94121': 'San Francisco', '94122': 'San Francisco', '94123': 'San Francisco',
    '94124': 'San Francisco', '94127': 'San Francisco', '94129': 'San Francisco',
    '94130': 'San Francisco', '94131': 'San Francisco', '94132': 'San Francisco',
    '94133': 'San Francisco', '94134': 'San Francisco', '94158': 'San Francisco',
    // LA neighborhoods
    '90210': 'Beverly Hills', '90211': 'Beverly Hills', '90212': 'Beverly Hills',
    '90046': 'West Hollywood', '90069': 'West Hollywood', '90048': 'Beverly Grove',
    '90028': 'Hollywood', '90038': 'Hollywood', '90068': 'Hollywood Hills',
    '90401': 'Santa Monica', '90402': 'Santa Monica', '90403': 'Santa Monica',
    '90404': 'Santa Monica', '90405': 'Santa Monica',
    '90291': 'Venice', '90292': 'Marina Del Rey', '90293': 'Playa Del Rey',
    '90049': 'Brentwood', '90077': 'Bel Air',
    '90230': 'Culver City', '90232': 'Culver City',
    '90272': 'Pacific Palisades', '90290': 'Topanga', '90265': 'Malibu',
    '91101': 'Pasadena', '91103': 'Pasadena', '91104': 'Pasadena',
    '91105': 'Pasadena', '91106': 'Pasadena', '91107': 'Pasadena',
    '91030': 'South Pasadena', '91108': 'San Marino',
    '91201': 'Glendale', '91202': 'Glendale', '91203': 'Glendale',
    '91204': 'Glendale', '91205': 'Glendale', '91206': 'Glendale',
    '91207': 'Glendale', '91208': 'Glendale',
    '91501': 'Burbank', '91502': 'Burbank', '91504': 'Burbank',
    '91505': 'Burbank', '91506': 'Burbank',
    '90501': 'Torrance', '90502': 'Torrance', '90503': 'Torrance',
    '90504': 'Torrance', '90505': 'Torrance', '90506': 'Torrance',
    '90301': 'Inglewood', '90302': 'Inglewood', '90303': 'Inglewood', '90305': 'Inglewood',
    '90245': 'El Segundo', '90266': 'Manhattan Beach',
    '90254': 'Hermosa Beach', '90277': 'Redondo Beach', '90278': 'Redondo Beach',
    '90274': 'Palos Verdes', '90275': 'Rancho Palos Verdes',
    '90731': 'San Pedro', '90732': 'San Pedro',
    '90802': 'Long Beach', '90803': 'Long Beach', '90804': 'Long Beach',
    '90805': 'Long Beach', '90806': 'Long Beach', '90807': 'Long Beach',
    '90808': 'Long Beach', '90810': 'Long Beach', '90813': 'Long Beach',
    '90814': 'Long Beach', '90815': 'Long Beach',
    '91601': 'North Hollywood', '91602': 'North Hollywood', '91604': 'Studio City',
    '91605': 'North Hollywood', '91606': 'North Hollywood', '91607': 'Valley Village',
    '91401': 'Van Nuys', '91402': 'Panorama City', '91403': 'Sherman Oaks',
    '91405': 'Van Nuys', '91406': 'Van Nuys', '91423': 'Sherman Oaks',
    '91436': 'Encino', '91316': 'Encino',
    '91356': 'Tarzana', '91364': 'Woodland Hills', '91367': 'Woodland Hills',
    '90094': 'Playa Vista', '90045': 'Westchester',
    '90220': 'Compton', '90221': 'Compton', '90222': 'Compton',
    '90240': 'Downey', '90241': 'Downey', '90242': 'Downey',
    '90250': 'Hawthorne', '90260': 'Lawndale',
    '90640': 'Montebello', '90660': 'Pico Rivera', '90280': 'South Gate',
    '90255': 'Huntington Park', '90201': 'Bell',
    '90601': 'Whittier', '90602': 'Whittier', '90603': 'Whittier',
    '90604': 'Whittier', '90605': 'Whittier', '90606': 'Whittier',
    '91754': 'Monterey Park', '91755': 'Monterey Park',
    '91001': 'Altadena', '91011': 'La Cañada Flintridge',
    '91040': 'Sunland', '91042': 'Tujunga',
    '91331': 'Pacoima', '91340': 'San Fernando', '91342': 'Sylmar',
    '91344': 'Granada Hills', '91324': 'Northridge', '91325': 'Northridge',
    '91311': 'Chatsworth', '91345': 'Mission Hills',
    // HNL neighborhoods
    '96701': 'Aiea', '96706': 'Ewa Beach', '96707': 'Kapolei',
    '96712': 'Haleiwa', '96717': 'Hauula', '96734': 'Kailua',
    '96744': 'Kaneohe', '96782': 'Pearl City', '96786': 'Wahiawa',
    '96789': 'Mililani', '96791': 'Waialua', '96792': 'Waianae',
    '96795': 'Waimanalo', '96797': 'Waipahu',
    '96813': 'Honolulu', '96814': 'Honolulu', '96815': 'Waikiki',
    '96816': 'Honolulu', '96817': 'Honolulu', '96818': 'Honolulu',
    '96819': 'Honolulu', '96821': 'Hawaii Kai', '96822': 'Honolulu',
    '96825': 'Hawaii Kai', '96826': 'Honolulu',
    '91320': 'Newbury Park', '93012': 'Camarillo', '91360': 'Thousand Oaks', '91361': 'Westlake Village', '91362': 'Thousand Oaks', '93010': 'Camarillo', '93033': 'Oxnard', '93042': 'Port Hueneme', '90265': 'Malibu', '91301': 'Agoura Hills', '91363': 'Woodland Hills', '91377': 'Oak Park', '93004': 'Ventura', '93021': 'Moorpark', '93030': 'Oxnard', '93035': 'Oxnard', '93036': 'Oxnard', '93041': 'Port Hueneme', '93043': 'Port Hueneme', '93066': 'Somis', '90263': 'Malibu', '91302': 'Calabasas', '91307': 'West Hills', '93003': 'Ventura', '93060': 'Santa Paula', '93063': 'Simi Valley', '93064': 'Simi Valley', '93065': 'Simi Valley', '93093': 'Simi Valley', '93099': 'Simi Valley', '91303': 'Canoga Park', '91304': 'Canoga Park', '91311': 'Chatsworth', '91367': 'Woodland Hills', '93009': 'Ventura', '93015': 'Fillmore', '91355': 'Valencia', '91381': 'Stevenson Ranch', '93001': 'Ventura', '93022': 'Oak View',
    // OC neighborhoods
    '90620': 'Buena Park', '90621': 'Buena Park', '90623': 'La Palma', '90630': 'Cypress', '90631': 'La Habra', '90680': 'Stanton', '90720': 'Los Alamitos', '90740': 'Seal Beach', '92602': 'Irvine', '92603': 'Irvine', '92604': 'Irvine', '92606': 'Irvine', '92610': 'Foothill Ranch', '92612': 'Irvine', '92614': 'Irvine', '92617': 'Irvine', '92618': 'Irvine', '92620': 'Irvine', '92625': 'Corona del Mar', '92626': 'Costa Mesa', '92627': 'Costa Mesa', '92629': 'Dana Point', '92630': 'Lake Forest', '92637': 'Laguna Woods', '92646': 'Huntington Beach', '92647': 'Huntington Beach', '92648': 'Huntington Beach', '92649': 'Huntington Beach', '92651': 'Laguna Beach', '92653': 'Laguna Hills', '92655': 'Midway City', '92656': 'Aliso Viejo', '92657': 'Newport Coast', '92660': 'Newport Beach', '92661': 'Newport Beach', '92662': 'Newport Beach', '92663': 'Newport Beach', '92675': 'San Juan Capistrano', '92676': 'Silverado', '92677': 'Laguna Niguel', '92679': 'Trabuco Canyon', '92683': 'Westminster', '92688': 'Rancho Santa Margarita', '92691': 'Mission Viejo', '92692': 'Mission Viejo', '92694': 'Ladera Ranch', '92697': 'Irvine', '92698': 'Aliso Viejo', '92701': 'Santa Ana', '92703': 'Santa Ana', '92704': 'Santa Ana', '92705': 'Santa Ana', '92706': 'Santa Ana', '92707': 'Santa Ana', '92708': 'Fountain Valley', '92709': 'Irvine', '92710': 'Irvine', '92725': 'Santa Ana', '92780': 'Tustin', '92782': 'Tustin', '92799': 'Santa Ana', '92801': 'Anaheim', '92802': 'Anaheim', '92804': 'Anaheim', '92805': 'Anaheim', '92806': 'Anaheim', '92807': 'Anaheim', '92808': 'Anaheim', '92809': 'Anaheim', '92821': 'Brea', '92831': 'Fullerton', '92832': 'Fullerton', '92833': 'Fullerton', '92835': 'Fullerton', '92840': 'Garden Grove', '92841': 'Garden Grove', '92843': 'Garden Grove', '92844': 'Garden Grove', '92845': 'Garden Grove', '92850': 'Anaheim', '92861': 'Villa Park', '92862': 'Orange', '92865': 'Orange', '92866': 'Orange', '92867': 'Orange', '92868': 'Orange', '92869': 'Orange', '92870': 'Placentia', '92886': 'Yorba Linda', '92887': 'Yorba Linda', '92899': 'Anaheim',
    // IE neighborhoods
    '91701': 'Rancho Cucamonga', '91708': 'Chino', '91709': 'Chino Hills', '91710': 'Chino', '91711': 'Claremont', '91724': 'Covina', '91730': 'Rancho Cucamonga', '91737': 'Rancho Cucamonga', '91739': 'Rancho Cucamonga', '91740': 'Glendora', '91741': 'Glendora', '91750': 'La Verne', '91752': 'Eastvale', '91758': 'Ontario', '91761': 'Ontario', '91762': 'Ontario', '91763': 'Montclair', '91764': 'Ontario', '91765': 'Diamond Bar', '91766': 'Pomona', '91767': 'Pomona', '91768': 'Pomona', '91773': 'San Dimas', '91784': 'Upland', '91786': 'Upland', '91789': 'Walnut', '91795': 'Walnut', '91798': 'Ontario', '91799': 'Pomona', '92313': 'Grand Terrace', '92316': 'Bloomington', '92324': 'Colton', '92335': 'Fontana', '92336': 'Fontana', '92337': 'Fontana', '92358': 'Lytle Creek', '92376': 'Rialto', '92377': 'Rialto', '92401': 'San Bernardino', '92403': 'San Bernardino', '92405': 'San Bernardino', '92407': 'San Bernardino', '92410': 'San Bernardino', '92411': 'San Bernardino', '92415': 'San Bernardino', '92418': 'San Bernardino', '92424': 'San Bernardino', '92501': 'Riverside', '92503': 'Riverside', '92504': 'Riverside', '92505': 'Riverside', '92506': 'Riverside', '92507': 'Riverside', '92509': 'Jurupa Valley', '92521': 'Riverside', '92522': 'Riverside', '92823': 'Brea', '92860': 'Norco', '92878': 'Corona', '92879': 'Corona', '92880': 'Eastvale', '92881': 'Corona', '92882': 'Corona'
  ,
    // Geo-filled cities (zippopotam 2026-07-05)
    '90001': 'Los Angeles', '90002': 'Los Angeles', '90003': 'Los Angeles', '90004': 'Los Angeles', '90005': 'Los Angeles', '90006': 'Los Angeles', '90007': 'Los Angeles', '90008': 'Los Angeles', '90010': 'Los Angeles', '90011': 'Los Angeles', '90012': 'Los Angeles', '90013': 'Los Angeles', '90014': 'Los Angeles', '90015': 'Los Angeles', '90016': 'Los Angeles', '90017': 'Los Angeles', '90018': 'Los Angeles', '90019': 'Los Angeles', '90020': 'Los Angeles', '90021': 'Los Angeles', '90022': 'Los Angeles', '90023': 'Los Angeles', '90024': 'Los Angeles', '90025': 'Los Angeles', '90026': 'Los Angeles', '90027': 'Los Angeles', '90029': 'Los Angeles', '90031': 'Los Angeles', '90032': 'Los Angeles', '90033': 'Los Angeles', '90034': 'Los Angeles', '90035': 'Los Angeles', '90036': 'Los Angeles', '90037': 'Los Angeles', '90039': 'Los Angeles', '90040': 'Los Angeles', '90041': 'Los Angeles', '90042': 'Los Angeles', '90043': 'Los Angeles', '90044': 'Los Angeles', '90047': 'Los Angeles', '90056': 'Los Angeles', '90057': 'Los Angeles', '90058': 'Los Angeles', '90059': 'Los Angeles', '90061': 'Los Angeles', '90062': 'Los Angeles', '90063': 'Los Angeles', '90064': 'Los Angeles', '90065': 'Los Angeles', '90066': 'Los Angeles', '90067': 'Los Angeles', '90071': 'Los Angeles', '90074': 'Los Angeles', '90079': 'Los Angeles', '90084': 'Los Angeles', '90088': 'Los Angeles', '90089': 'Los Angeles', '90095': 'Los Angeles', '90096': 'Los Angeles', '90099': 'Los Angeles', '90101': 'Los Angeles', '90102': 'Los Angeles', '90103': 'Los Angeles', '90189': 'Los Angeles', '90247': 'Gardena', '90248': 'Gardena', '90249': 'Gardena', '90261': 'Lawndale', '90262': 'Lynwood', '90270': 'Maywood', '90304': 'Inglewood', '90311': 'Inglewood', '90313': 'Inglewood', '90397': 'Inglewood', '90398': 'Inglewood', '90612': 'Whittier', '90638': 'La Mirada', '90639': 'La Mirada', '90650': 'Norwalk', '90659': 'Norwalk', '90670': 'Santa Fe Springs', '90701': 'Artesia', '90703': 'Cerritos', '90706': 'Bellflower', '90710': 'Harbor City', '90712': 'Lakewood', '90713': 'Lakewood', '90715': 'Lakewood', '90716': 'Hawaiian Gardens', '90717': 'Lomita', '90723': 'Paramount', '90744': 'Wilmington', '90745': 'Carson', '90746': 'Carson', '90747': 'Carson', '90755': 'Signal Hill', '90822': 'Long Beach', '90831': 'Long Beach', '90833': 'Long Beach', '90834': 'Long Beach', '90835': 'Long Beach', '90840': 'Long Beach', '90842': 'Long Beach', '90844': 'Long Beach', '90845': 'Long Beach', '90846': 'Long Beach', '90847': 'Long Beach', '90848': 'Long Beach', '90888': 'Long Beach', '90895': 'Carson', '90899': 'Long Beach', '91006': 'Arcadia', '91007': 'Arcadia', '91008': 'Duarte', '91010': 'Duarte', '91016': 'Monrovia', '91020': 'Montrose', '91024': 'Sierra Madre', '91110': 'Pasadena', '91121': 'Pasadena', '91123': 'Pasadena', '91124': 'Pasadena', '91125': 'Pasadena', '91126': 'Pasadena', '91129': 'Pasadena', '91131': 'Pasadena', '91182': 'Pasadena', '91184': 'Pasadena', '91185': 'Pasadena', '91188': 'Pasadena', '91189': 'Pasadena', '91191': 'Pasadena', '91199': 'Pasadena', '91210': 'Glendale', '91214': 'La Crescenta', '91306': 'Winnetka', '91321': 'Newhall', '91326': 'Northridge', '91329': 'Northridge', '91330': 'Northridge', '91335': 'Reseda', '91343': 'North Hills', '91351': 'Canyon Country', '91352': 'Sun Valley', '91382': 'Santa Clarita', '91383': 'Santa Clarita', '91387': 'Canyon Country', '91388': 'Van Nuys', '91399': 'Woodland Hills', '91411': 'Van Nuys', '91470': 'Van Nuys', '91482': 'Van Nuys', '91495': 'Sherman Oaks', '91496': 'Van Nuys', '91497': 'Van Nuys', '91499': 'Van Nuys', '91521': 'Burbank', '91522': 'Burbank', '91523': 'Burbank', '91526': 'Burbank', '91608': 'Universal City', '91611': 'North Hollywood', '91612': 'North Hollywood', '91702': 'Azusa', '91706': 'Baldwin Park', '91722': 'Covina', '91723': 'Covina', '91731': 'El Monte', '91732': 'El Monte', '91733': 'South El Monte', '91735': 'El Monte', '91744': 'La Puente', '91745': 'Hacienda Heights', '91746': 'La Puente', '91748': 'Rowland Heights', '91756': 'Monterey Park', '91770': 'Rosemead', '91771': 'Rosemead', '91772': 'Rosemead', '91775': 'San Gabriel', '91776': 'San Gabriel', '91780': 'Temple City', '91790': 'West Covina', '91791': 'West Covina', '91792': 'West Covina', '91797': 'Pomona', '91801': 'Alhambra', '91803': 'Alhambra', '91804': 'Alhambra', '91841': 'Alhambra', '93550': 'Palmdale', '94003': 'Belmont', '94005': 'Brisbane', '94011': 'Burlingame', '94012': 'Burlingame', '94013': 'Daly City', '94017': 'Daly City', '94018': 'El Granada', '94019': 'Half Moon Bay', '94022': 'Los Altos', '94023': 'Los Altos', '94024': 'Los Altos', '94025': 'Menlo Park', '94026': 'Menlo Park', '94027': 'Atherton', '94029': 'Menlo Park', '94031': 'Millbrae', '94035': 'Mountain View', '94037': 'Montara', '94038': 'Moss Beach', '94039': 'Mountain View', '94040': 'Mountain View', '94041': 'Mountain View', '94042': 'Mountain View', '94043': 'Mountain View', '94045': 'Pacifica', '94059': 'Redwood City', '94064': 'Redwood City', '94067': 'San Bruno', '94071': 'San Carlos', '94074': 'San Gregorio', '94089': 'Sunnyvale', '94096': 'San Bruno', '94098': 'San Bruno', '94099': 'South San Francisco', '94101': 'San Francisco', '94106': 'San Francisco', '94119': 'San Francisco', '94120': 'San Francisco', '94125': 'San Francisco', '94126': 'San Francisco', '94128': 'San Francisco', '94135': 'San Francisco', '94136': 'San Francisco', '94137': 'San Francisco', '94138': 'San Francisco', '94139': 'San Francisco', '94140': 'San Francisco', '94141': 'San Francisco', '94142': 'San Francisco', '94143': 'San Francisco', '94144': 'San Francisco', '94145': 'San Francisco', '94146': 'San Francisco', '94147': 'San Francisco', '94150': 'San Francisco', '94151': 'San Francisco', '94152': 'San Francisco', '94153': 'San Francisco', '94154': 'San Francisco', '94155': 'San Francisco', '94156': 'San Francisco', '94157': 'San Francisco', '94159': 'San Francisco', '94160': 'San Francisco', '94161': 'San Francisco', '94162': 'San Francisco', '94163': 'San Francisco', '94164': 'San Francisco', '94165': 'San Francisco', '94166': 'San Francisco', '94167': 'San Francisco', '94168': 'San Francisco', '94169': 'San Francisco', '94170': 'San Francisco', '94171': 'San Francisco', '94172': 'San Francisco', '94175': 'San Francisco', '94177': 'San Francisco', '94188': 'San Francisco', '94199': 'San Francisco', '94301': 'Palo Alto', '94302': 'Palo Alto', '94303': 'Palo Alto', '94304': 'Palo Alto', '94305': 'Stanford', '94306': 'Palo Alto', '94307': 'Palo Alto', '94308': 'Palo Alto', '94309': 'Palo Alto', '94310': 'Palo Alto', '94405': 'San Mateo', '94407': 'San Mateo', '94408': 'San Mateo', '94409': 'San Mateo', '94497': 'San Mateo', '94503': 'American Canyon', '94506': 'Danville', '94510': 'Benicia', '94517': 'Clayton', '94519': 'Concord', '94520': 'Concord', '94521': 'Concord', '94522': 'Concord', '94524': 'Concord', '94525': 'Crockett', '94527': 'Concord', '94529': 'Concord', '94536': 'Fremont', '94537': 'Fremont', '94538': 'Fremont', '94539': 'Fremont', '94540': 'Hayward', '94543': 'Hayward', '94547': 'Hercules', '94557': 'Hayward', '94559': 'Napa', '94560': 'Newark', '94564': 'Pinole', '94565': 'Pittsburg', '94566': 'Pleasanton', '94568': 'Dublin', '94569': 'Port Costa', '94570': 'Moraga', '94572': 'Rodeo', '94575': 'Moraga', '94582': 'San Ramon', '94583': 'San Ramon', '94586': 'Sunol', '94587': 'Union City', '94588': 'Pleasanton', '94589': 'Vallejo', '94590': 'Vallejo', '94591': 'Vallejo', '94592': 'Vallejo', '94617': 'Oakland', '94620': 'Piedmont', '94626': 'Oakland', '94627': 'Oakland', '94643': 'Oakland', '94659': 'Oakland', '94666': 'Oakland', '94712': 'Berkeley', '94807': 'Richmond', '94808': 'Richmond', '94850': 'Richmond', '94912': 'San Rafael', '94913': 'San Rafael', '94914': 'Kentfield', '94915': 'San Rafael', '94924': 'Bolinas', '94930': 'Fairfax', '94933': 'Forest Knolls', '94938': 'Lagunitas', '94942': 'Mill Valley', '94945': 'Novato', '94946': 'Nicasio', '94947': 'Novato', '94948': 'Novato', '94949': 'Novato', '94950': 'Olema', '94952': 'Petaluma', '94953': 'Petaluma', '94954': 'Petaluma', '94955': 'Petaluma', '94956': 'Point Reyes Station', '94957': 'Ross', '94963': 'San Geronimo', '94966': 'Sausalito', '94970': 'Stinson Beach', '94973': 'Woodacre', '94975': 'Petaluma', '94976': 'Corte Madera', '94977': 'Larkspur', '94978': 'Fairfax', '94979': 'San Anselmo', '94998': 'Novato', '94999': 'Petaluma', '95002': 'Alviso', '95476': 'Sonoma', '96709': 'Kapolei', '96730': 'Kaaawa', '96731': 'Kahuku', '96759': 'Kunia', '96762': 'Laie', '96801': 'Honolulu', '96802': 'Honolulu', '96803': 'Honolulu', '96804': 'Honolulu', '96805': 'Honolulu', '96806': 'Honolulu', '96807': 'Honolulu', '96808': 'Honolulu', '96809': 'Honolulu', '96810': 'Honolulu', '96811': 'Honolulu', '96812': 'Honolulu', '96820': 'Honolulu', '96823': 'Honolulu', '96824': 'Honolulu', '96827': 'Honolulu', '96828': 'Honolulu', '96830': 'Honolulu', '96835': 'Honolulu', '96836': 'Honolulu', '96837': 'Honolulu', '96838': 'Honolulu', '96839': 'Honolulu', '96840': 'Honolulu', '96841': 'Honolulu', '96842': 'Honolulu', '96843': 'Honolulu', '96844': 'Honolulu', '96845': 'Honolulu', '96846': 'Honolulu', '96847': 'Honolulu', '96848': 'Honolulu', '96849': 'Honolulu', '96850': 'Honolulu', '96858': 'Fort Shafter',
    // Oahu military bases (Matt 2026-07-05)
    '96853': 'Hickam AFB', '96854': 'Wheeler Army Airfield', '96857': 'Schofield Barracks', '96859': 'Tripler Army Medical Center', '96860': 'Pearl Harbor', '96861': 'Camp H.M. Smith', '96862': 'Barbers Point', '96863': 'MCBH'};

  function getLocalName(zip) {
    return ZIP_LOCAL_NAMES[String(zip)] || null;
  }

  function updateHeroHeading(zip) {
    var localName = getLocalName(zip);
    if (!localName) return;

    var headingText = localName.toUpperCase() + ' FLORIST';

    var blocks = document.querySelectorAll('.region-slideshow');
    var visibleBlock = null;
    for (var i = 0; i < blocks.length; i++) {
      if (getComputedStyle(blocks[i]).display !== 'none') {
        visibleBlock = blocks[i];
        break;
      }
    }
    if (!visibleBlock) return;

    var heading = visibleBlock.querySelector('.ami-slideshow__item-content h1, .ami-slideshow__item-content h2');
    if (heading) heading.innerHTML = '<strong>' + headingText + '</strong>';

    var subtitle = visibleBlock.querySelector('.ami-slideshow__item-content aside h3');
    if (subtitle) subtitle.innerHTML = '<strong>Event decorations and flower delivery in ' + localName + '</strong>';
  }

  document.addEventListener('click', function(e) {
    var btn = document.getElementById('zip-code-submit');
    if (!btn) return;
    if (e.target === btn || (e.target.closest && e.target.closest('#zip-code-submit'))) {
      var input = document.getElementById('zip-code-input');
      var zip = input ? (input.value || '').trim() : '';
      if (zip && /^\d{5}$/.test(zip)) {
        localStorage.setItem('pc_selected_zip', zip);
      }
    }
  }, true);

  var CITY_PHONES = {
    la: '(424) 303-2205',
    sf: '(415) 360-1333',
    hnl: '(808) 808-6616',
    vc: '(805) 870-9996',
    oc: '(657) 300-4404',
    ie: '(951) 666-8848'
  };

  function updateAnnouncementPhone(city) {
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    else if (city === 'orange_county' || city === 'oc') suffix = 'oc';
    else if (city === 'inland_empire' || city === 'ie') suffix = 'ie';
    var phone = CITY_PHONES[suffix] || CITY_PHONES.la;
    var textEl = document.getElementById('announcement-phone-text');
    var linkEl = document.getElementById('announcement-phone-link');
    if (textEl) textEl.textContent = phone;
    if (linkEl) linkEl.href = 'tel:+1' + phone.replace(/[^0-9]/g, '');
  }

  var origApplyCity = window.applyRegion;
  window.applyRegion = function(city) {
    if (origApplyCity) origApplyCity(city);
    showCityTextSections(city);
    updateAnnouncementPhone(city);
    updateCollectionRegion(city);
    updateProductRegion(city);
    updateFooterRegion(city);
    var zip = localStorage.getItem('pc_selected_zip') || '';
    if (zip) {
      var zipCity = getCityByZip(zip);
      if (zipCity === city) {
        updateHeroHeading(zip);
      } else {
        localStorage.removeItem('pc_selected_zip');
      }
    }
  };



  function updateFooterRegion(city) {
    var names = { la: 'Los Angeles', sf: 'San Francisco', hnl: 'Honolulu', vc: 'Ventura County' };
    var delivHref = { la: '/pages/flower-delivery-la', sf: '/pages/san-francisco', hnl: '/collections/main-collection-hnl', vc: '/collections/all-flowers' };
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    var name = names[suffix];
    var links = document.querySelectorAll('.footer a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.hasAttribute('data-pc-orig')) {
        if (a.textContent.indexOf('Los Angeles') === -1) continue;
        a.setAttribute('data-pc-orig', a.textContent);
        a.setAttribute('data-pc-orig-href', a.getAttribute('href') || '');
      }
      var orig = a.getAttribute('data-pc-orig');
      a.textContent = orig.replace(/Los Angeles/g, name);
      if (orig.indexOf('Flower Delivery') !== -1) {
        a.setAttribute('href', delivHref[suffix] || a.getAttribute('data-pc-orig-href'));
      }
    }
  }
  window.updateFooterRegion = updateFooterRegion;

  function updateCollectionRegion(city) {
    // Region from collection URL (collection's own region); else visitor city
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    var pcm = window.location.pathname.match(/\/collections\/[^\/]*-(vc|hnl|sf)(?:\/|$)/);
    if (pcm) suffix = pcm[1];
    if (suffix === 'la') return; // LA: nothing to localize
    var names = { sf: 'San Francisco', hnl: 'Honolulu', vc: 'Ventura County' };
    var across = { sf: 'the Bay Area', hnl: 'Oahu', vc: 'Ventura County' };
    var name = names[suffix], acr = across[suffix];
    // Replace via TEXT NODES only (nodeValue change = no childList mutation -> no observer loop -> grid stays intact)
    function swapText(root) {
      if (!root || root.getAttribute('data-pc-localized')) return;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        if (v.indexOf('Los Angeles') !== -1 || v.indexOf('LOS ANGELES') !== -1 || /across LA\b/.test(v)) {
          n.nodeValue = v.replace(/LOS ANGELES/g, name.toUpperCase()).replace(/Los Angeles/g, name).replace(/across LA\b/g, 'across ' + acr);
        }
      }
      root.setAttribute('data-pc-localized', '1');
    }
    swapText(document.querySelector('[id$="__image_with_text_TdnByX"]'));
    swapText(document.querySelector('[id$="__rich_text_QKwxPW"]'));
  }
  window.updateCollectionRegion = updateCollectionRegion;

  /** Localize product description for regions sharing the LA catalog (2026-07-06) */
  function updateProductRegion(city) {
    if (!/^\/products\//.test(window.location.pathname)) return;
    var suffix = null;
    if (city === 'orange_county' || city === 'oc') suffix = 'oc';
    else if (city === 'inland_empire' || city === 'ie') suffix = 'ie';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    if (!suffix) return;
    var names = { oc: 'Orange County', ie: 'Inland Empire', vc: 'Ventura County' };
    var cityLists = {
      oc: 'Irvine, Anaheim, Santa Ana, Newport Beach, Costa Mesa, Huntington Beach, Tustin, Fullerton, Orange, Mission Viejo, Laguna Beach',
      ie: 'Ontario, Rancho Cucamonga, Chino, Chino Hills, Pomona, Upland, Fontana, Riverside, Corona, Eastvale, San Bernardino',
      vc: 'Ventura, Oxnard, Thousand Oaks, Camarillo, Simi Valley, Moorpark, Newbury Park, Ojai, Calabasas, Malibu, Hidden Hills'
    };
    var LA_LIST = 'Downtown LA, Beverly Hills, Santa Monica, Hollywood, Pasadena, Glendale, Burbank, Long Beach, Culver City, Sherman Oaks, Manhattan Beach';
    var name = names[suffix], list = cityLists[suffix], phone = CITY_PHONES[suffix] || CITY_PHONES.la;
    var root = document.querySelector('.product__description');
    if (!root || root.getAttribute('data-pc-region-localized')) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (v.indexOf(LA_LIST) !== -1) v = v.split(LA_LIST).join(list);
      if (v.indexOf('Los Angeles') !== -1) v = v.split('Los Angeles').join(name);
      if (v.indexOf('LOS ANGELES') !== -1) v = v.split('LOS ANGELES').join(name.toUpperCase());
      if (v.indexOf('(424) 303-2205') !== -1) v = v.split('(424) 303-2205').join(phone);
      if (v !== n.nodeValue) n.nodeValue = v;
    }
    var tels = root.querySelectorAll('a[href*="tel:"]');
    for (var t = 0; t < tels.length; t++) {
      if ((tels[t].getAttribute('href') || '').indexOf('4243032205') !== -1) {
        tels[t].setAttribute('href', 'tel:1' + phone.replace(/\D/g, ''));
      }
    }
    root.setAttribute('data-pc-region-localized', suffix);
  }
  window.updateProductRegion = updateProductRegion;


  function showCityTextSections(city) {
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    else if (city === 'orange_county' || city === 'oc') suffix = 'oc';
    else if (city === 'inland_empire' || city === 'ie') suffix = 'ie';

    var pairs = [
      ['__image_with_content_XfFXaY', 'la'],
      ['__image_with_content_XfFXaY_SF', 'sf'],
      ['__image_with_content_XfFXaY_HNL', 'hnl'],
      ['__image_with_content_XfFXaY_VC', 'vc'],
      ['__image_with_content_XfFXaY_OC', 'oc'],
      ['__image_with_content_XfFXaY_IE', 'ie']
    ];
    for (var i = 0; i < pairs.length; i++) {
      var el = document.querySelector('[id$="' + pairs[i][0] + '"]');
      if (el) el.style.display = (pairs[i][1] === suffix) ? '' : 'none';
    }

    // Region-variant content INSIDE a section via inner [data-pc-region] blocks (HNL -> LA fallback)
    var innerSections = ['__home_locations_div', '__home_faq_brand_v2'];
    var want = (suffix === 'sf' || suffix === 'vc' || suffix === 'hnl' || suffix === 'oc' || suffix === 'ie') ? suffix : 'la';
    for (var s = 0; s < innerSections.length; s++) {
      var sec = document.querySelector('[id$="' + innerSections[s] + '"]');
      if (!sec) continue;
      var regs = sec.querySelectorAll('[data-pc-region]');
      if (!regs.length) continue;
      var has = false;
      for (var q = 0; q < regs.length; q++) { if (regs[q].getAttribute('data-pc-region') === want) { has = true; break; } }
      var show = has ? want : 'la';
      for (var r = 0; r < regs.length; r++) {
        regs[r].style.display = (regs[r].getAttribute('data-pc-region') === show) ? '' : 'none';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var city = getCookie(COOKIE_NAME) || getCityFromUrl() || (window.__STORE_CITY_FROM_CART__) || null;
    if (city) {
      showCityTextSections(city);
      updateAnnouncementPhone(city);
      updateCollectionRegion(city);
      updateProductRegion(city);
      updateFooterRegion(city);
    } else {
      showCityTextSections('los_angeles');
      updateAnnouncementPhone('los_angeles');
      updateCollectionRegion('los_angeles');
      updateFooterRegion('los_angeles');
    }
    var zip = localStorage.getItem('pc_selected_zip') || '';
    if (zip) {
      var currentCity = city || 'los_angeles';
      var zipCity = getCityByZip(zip);
      if (zipCity === currentCity) {
        setTimeout(function() { updateHeroHeading(zip); }, 600);
      } else {
        localStorage.removeItem('pc_selected_zip');
      }
    }
  });

  window.updateHeroHeading = updateHeroHeading;
  window.getLocalName = getLocalName;
  window.showCityTextSections = showCityTextSections;

})();
